module.exports = __webpack_public_path__ + "img/sparkleWhite.158e75c.svg";